import { useState } from 'react';
import { FileTextOutlined } from '@ant-design/icons';

import { Button, Dialog } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import type { DongLichSu } from '../../types';
import { HopLogRobot } from './HopLogRobot';
import { KhoiBaoCaoLoi } from './KhoiBaoCaoLoi';

/** Báo cáo lỗi của một lượt chạy ở Lịch sử, gắn theo InstanceId; mở tiếp được log Robot của chính lượt đó. */
export function HopBaoCaoInstance({ dong, onClose }: { dong: DongLichSu; onClose: () => void }) {
  const { t } = useT();
  const [xemLog, setXemLog] = useState(false);
  const ten = dong.name || dong.workflowId || dong.id;
  return (
    <Dialog
      open
      onClose={onClose}
      width={880}
      title={t('rpaLichSu.hopLoiTieuDe', { ten })}
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          {dong.robotLog && (
            <Button variant="outline" size="md" icon={<FileTextOutlined />} onClick={() => setXemLog(true)}>
              {t('rpaLichSu.xemLogRobot')}
            </Button>
          )}
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.dong')}
          </Button>
        </div>
      }
    >
      <KhoiBaoCaoLoi instanceId={dong.instanceId} />
      {xemLog && <HopLogRobot instanceId={dong.instanceId} ten={ten} onClose={() => setXemLog(false)} />}
    </Dialog>
  );
}
